module.exports = __webpack_public_path__ + "static/wilson-ec6a9d070561add432c6462c571d02a2.jpg";